export enum AppCertificateEnum {
  NEW_SILK_ROAD = 'new-silk-road-network',
  PROJECT_LOGISTICS = 'project-logistics-alliance',
  MOTION_LOGISTICS = 'motion-logistics-network',
  PULP_NETWORK = 'pulp-network',
}
